'use client'

import { useTranslations } from 'next-intl'
import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import styles from './IkadRenewal.module.css'

function FadeIn({ children, className }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref, { once: false, margin: '-80px' })
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 24 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}

export default function IkadRenewal() {
  const t = useTranslations('VisaGuidePage.renewalTabs.ikadRenewal')

  const DOC_KEYS = ['1', '2', '3', '4', '5', '6', '7'] as const
  const COLLECTION_DOC_KEYS = ['1', '2'] as const
  const NOTE_KEYS = ['1', '2'] as const

  return (
  <section className={styles.section}>
    <div className={styles.container}>

      <h2 className={styles.title}>{t('title')}</h2>

      {/* Important Notes */}
      <FadeIn className={styles.notesSection}>
        <h3 className={styles.sectionSubtitle}>{t('notesTitle')}</h3>
        <ul className={styles.simpleList}>
          {NOTE_KEYS.map((k) => (
            <li key={k} className={styles.simpleItem}>
              <span className={styles.dot} />
              <span>{t(`notes.${k}`)}</span>
            </li>
          ))}
        </ul>
      </FadeIn>

      {/* Form Button + notes */}
      <FadeIn className={styles.overviewSection}>
      <a
          href="https://forms.gle/dcZpN2CLqcWnqF63A"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.formButton}
        >
          {t('formButton')}
        </a>
        <ul className={styles.simpleList}>
          <li className={styles.simpleItem}>
            <span className={styles.dot} />
            <span>{t('deadline')}</span>
          </li>
          <li className={styles.simpleItem}>
            <span className={styles.dot} />
            <span>{t('yearlyNote')}</span>
          </li>
        </ul>
      </FadeIn>

      {/* Required Documents */}
      <FadeIn className={styles.docsSection}>
        <h3 className={styles.sectionSubtitle}>{t('docsTitle')}</h3>
        <ul className={styles.docsList}>
          {DOC_KEYS.map((k) => (
            <li key={k} className={styles.docsItem}>
              <span className={styles.docsNumber}>{k}</span>
              <span className={styles.docsLabel}>{t(`docsList.${k}`)}</span>
            </li>
          ))}
        </ul>
      </FadeIn>

      {/* iKad Collection */}
      <FadeIn className={styles.collectionSection}>
        <h3 className={styles.sectionSubtitle}>{t('collectionTitle')}</h3>
        <ul className={styles.simpleList}>
          <li className={styles.simpleItem}>
            <span className={styles.dot} />
            <span>{t('collectionDesc')}</span>
          </li>
          <li className={styles.simpleItem}>
            <span className={styles.dot} />
            <span>{t('collectionNoEmail')}</span>
          </li>
        </ul>
        <h4 className={styles.subTitle}>{t('collectionDocsTitle')}</h4>
        <ul className={styles.simpleList}>
          {COLLECTION_DOC_KEYS.map((k) => (
            <li key={k} className={styles.simpleItem}>
              <span className={styles.dot} />
              <span>{t(`collectionDocs.${k}`)}</span>
            </li>
          ))}
        </ul>
      </FadeIn>

    </div>
  </section>
)
}